import { render, staticRenderFns } from "./FreeFormViewTwo.vue?vue&type=template&id=c27d2d64&"
import script from "./FreeFormViewTwo.vue?vue&type=script&lang=js&"
export * from "./FreeFormViewTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports